/* Nicola Fasano-serier, A+B (2026-10-23)
   - Punkter på miljöbilder (placeras efter bildens beskärning)
   - Serieremsans pilar
   - Komplettera bordet och Duka för fyra: flera pjäser i korgen på en gång
   - Kollektionssidan: korten delas upp i kapitel med meny som följer med */
(function () {
  if (window.__tamburSerie) return;
  window.__tamburSerie = true;

  // Kapitel efter första ordet i handle – samma lista som snippets/serie-grupp.liquid
  var GRUPP = {
    middagstallrik: 'duka', djup: 'duka', assiett: 'duka', desserttallrik: 'duka', frukostskal: 'duka',
    miniskal: 'duka', kaffekopp: 'duka', kaffemugg: 'duka', smorgasfat: 'duka',
    forvaringsburk: 'forvara', smorbytta: 'forvara', slevhallare: 'forvara', bunke: 'forvara', vas: 'forvara'
  };
  var ORDNING = ['duka', 'servera', 'forvara'];

  function txt(el, namn) { return ((el && el.getAttribute(namn)) || '').trim(); }

  function pris(oren) {
    var iso = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
    var hel = Math.round(oren / 100);
    if (iso === 'SEK') return hel.toLocaleString('sv-SE') + ' kr';
    if (iso === 'EUR') return hel + ' EUR';
    return (oren / 100).toFixed(2) + ' ' + iso;
  }

  /* ---------- Korgen (samma flöde som hyllan) ---------- */
  function synkaKorg() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
        if (window.TamburCartDrawer && typeof window.TamburCartDrawer.refresh === 'function') return window.TamburCartDrawer.refresh();
      })
      .catch(function () {});
  }
  function oppnaKorg() {
    var t = document.querySelector('[data-cart-drawer-open]');
    if (t) t.click();
  }
  function laggIKorg(rader) {
    rader = rader.filter(function (r) { return r.id && r.quantity > 0; });
    if (!rader.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: rader })
    }).then(function (res) {
      return res.json().then(function (data) { if (!res.ok) throw data; return data; });
    }).then(function (data) {
      (data && Array.isArray(data.items) ? data.items : [data]).forEach(function (item) {
        document.dispatchEvent(new CustomEvent('tambur:tracking:add-to-cart', { detail: item }));
      });
      return synkaKorg().then(function () {
        var d = window.TamburAtcFeedback && window.TamburAtcFeedback.drawerDelayMs ? window.TamburAtcFeedback.drawerDelayMs() : 0;
        if (d > 0) setTimeout(oppnaKorg, d); else oppnaKorg();
      });
    });
  }
  function knappLaddar(knapp, lofte) {
    knapp.disabled = true;
    lofte.then(function () {
      knapp.classList.add('is-klar');
      setTimeout(function () { knapp.classList.remove('is-klar'); knapp.disabled = false; }, 1600);
    }).catch(function (e) {
      knapp.disabled = false;
      alert((e && (e.description || e.message)) || 'Det gick inte att lägga i korgen.');
    });
  }

  /* ---------- Punkter ---------- */
  function placeraPunkter() {
    document.querySelectorAll('[data-serie-pb]').forEach(function (box) {
      var img = box.querySelector(':scope > img');
      if (!img || !img.naturalWidth || !box.offsetWidth) return;
      var bw = box.offsetWidth, bh = box.offsetHeight, iw = img.naturalWidth, ih = img.naturalHeight;
      var sk = Math.max(bw / iw, bh / ih), dw = iw * sk, dh = ih * sk;
      var op = getComputedStyle(img).objectPosition.split(' ').map(function (v) { return parseFloat(v) / 100; });
      var ox = (bw - dw) * (isNaN(op[0]) ? .5 : op[0]), oy = (bh - dh) * (isNaN(op[1]) ? .5 : op[1]);
      // Punkter får inte ligga under seriens rubrik på den stora bilden
      var tit = box.parentNode && box.parentNode.querySelector('.serie-hero__titel'), tr = null;
      if (tit) {
        var r1 = box.getBoundingClientRect(), r2 = tit.getBoundingClientRect();
        tr = [r2.left - r1.left - 20, r2.top - r1.top - 20, r2.right - r1.left + 20, r2.bottom - r1.top + 20];
      }
      box.querySelectorAll('.serie-pkt').forEach(function (b) {
        var x = ox + b.dataset.x / 100 * dw, y = oy + b.dataset.y / 100 * dh;
        var iTitel = tr && x > tr[0] && x < tr[2] && y > tr[1] && y < tr[3];
        b.style.left = x + 'px';
        b.style.top = y + 'px';
        b.style.display = (iTitel || x < 16 || x > bw - 16 || y < 16 || y > bh - 16) ? 'none' : '';
        b.classList.toggle('serie-pkt--v', x > bw * .55);
      });
    });
  }
  function initPunkter(root) {
    (root || document).querySelectorAll('[data-serie-pb] > img').forEach(function (img) {
      if (img.complete) placeraPunkter(); else img.addEventListener('load', placeraPunkter, { once: true });
    });
    placeraPunkter();
  }
  document.addEventListener('click', function (e) {
    var lagg = e.target.closest('[data-serie-lagg]');
    if (lagg) {
      e.preventDefault(); e.stopPropagation();
      lagg.style.opacity = .5;
      laggIKorg([{ id: +lagg.getAttribute('data-serie-lagg'), quantity: 1 }])
        .then(function () { lagg.style.opacity = ''; })
        .catch(function () { lagg.style.opacity = ''; });
      return;
    }
    if (e.target.closest('.serie-pkt__kort')) return;
    var pkt = e.target.closest('.serie-pkt');
    document.querySelectorAll('.serie-pkt.is-on').forEach(function (p) { if (p !== pkt) p.classList.remove('is-on'); });
    if (pkt) pkt.classList.toggle('is-on');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.serie-pkt.is-on').forEach(function (p) { p.classList.remove('is-on'); });
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-serie-lagg]')) { e.preventDefault(); e.target.click(); }
  });
  window.addEventListener('resize', placeraPunkter);

  /* ---------- Remsan ---------- */
  function initRemsa() {
    document.querySelectorAll('[data-serie-remsa]').forEach(function (r) {
      var lista = r.querySelector('[data-serie-remsa-lista]');
      var vanster = r.querySelector('[data-serie-remsa-pil="-1"]'), hoger = r.querySelector('[data-serie-remsa-pil="1"]');
      if (!lista) return;
      function pilar() {
        if (vanster) vanster.hidden = lista.scrollLeft < 4;
        if (hoger) hoger.hidden = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
      }
      [vanster, hoger].forEach(function (b) {
        if (b) b.addEventListener('click', function () { lista.scrollBy({ left: +b.getAttribute('data-serie-remsa-pil') * lista.clientWidth * .8, behavior: 'smooth' }); });
      });
      lista.addEventListener('scroll', pilar, { passive: true });
      // Visa pjäsen man tittar på
      var har = lista.querySelector('.is-har');
      if (har) lista.scrollLeft = Math.max(0, har.parentNode.offsetLeft - lista.clientWidth / 2 + har.parentNode.offsetWidth / 2);
      pilar();
    });
  }

  /* ---------- Komplettera bordet ---------- */
  function initKomplettera() {
    document.querySelectorAll('[data-serie-komplettera]').forEach(function (k) {
      var summa = k.querySelector('[data-serie-summa]'), antal = k.querySelector('[data-serie-antal]'), knapp = k.querySelector('[data-serie-lagg-valda]');
      function rakna() {
        var s = 0, n = 0;
        k.querySelectorAll('[data-serie-val]:checked').forEach(function (c) { s += +c.getAttribute('data-pris'); n++; });
        if (summa) summa.textContent = pris(s);
        if (antal) antal.textContent = n + ' ' + txt(antal, 'data-text');
        if (knapp) knapp.disabled = n === 0;
      }
      k.addEventListener('change', rakna);
      rakna();
      if (knapp) knapp.addEventListener('click', function () {
        var rader = [];
        k.querySelectorAll('[data-serie-val]:checked').forEach(function (c) { rader.push({ id: +c.getAttribute('data-serie-val'), quantity: 1 }); });
        knappLaddar(knapp, laggIKorg(rader));
      });
    });
  }

  /* ---------- Duka för fyra ---------- */
  function initSet(set) {
    var summa = set.querySelector('[data-serie-set-summa]'), n = set.querySelector('[data-serie-set-n]'), knapp = set.querySelector('[data-serie-set-lagg]');
    function rakna() {
      var s = 0, st = 0;
      set.querySelectorAll('[data-serie-set-del]').forEach(function (d) {
        var a = +d.querySelector('[data-serie-steg-antal]').textContent;
        s += a * +d.getAttribute('data-pris'); st += a;
      });
      summa.textContent = pris(s);
      n.textContent = st + ' ' + txt(n, 'data-text');
      knapp.disabled = st === 0;
    }
    set.addEventListener('click', function (e) {
      var b = e.target.closest('[data-serie-steg]');
      if (!b) return;
      var el = b.parentNode.querySelector('[data-serie-steg-antal]');
      el.textContent = Math.max(0, Math.min(24, +el.textContent + +b.getAttribute('data-serie-steg')));
      rakna();
    });
    knapp.addEventListener('click', function () {
      var rader = [];
      set.querySelectorAll('[data-serie-set-del]').forEach(function (d) {
        rader.push({ id: +d.getAttribute('data-v'), quantity: +d.querySelector('[data-serie-steg-antal]').textContent });
      });
      knappLaddar(knapp, laggIKorg(rader));
    });
    rakna();
  }

  /* ---------- Kapitel på kollektionssidan ---------- */
  function initKapitel() {
    var wrap = document.querySelector('[data-serie-grid]');
    var data = document.querySelector('[data-serie-kapitel]');
    if (!wrap || !data || wrap.hasAttribute('data-serie-klar')) return;
    // Bara den rena serien: inga filter, sortering eller fler sidor att ladda
    if (/[?&](filter\.|sort_by=|page=)/.test(location.search) || wrap.getAttribute('data-next-url')) return;
    var grid = wrap.querySelector('[data-collection-grid]');
    if (!grid) return;
    var kort = Array.prototype.slice.call(grid.querySelectorAll(':scope > .tambur-product-card'));
    if (kort.length < 6) return;
    wrap.setAttribute('data-serie-klar', '');

    var grupper = { duka: [], servera: [], forvara: [] };
    kort.forEach(function (k) {
      var f = (k.getAttribute('data-product-handle') || '').split('-')[0];
      grupper[GRUPP[f] || 'servera'].push(k);
    });
    var anvanda = ORDNING.filter(function (g) { return grupper[g].length; });
    if (anvanda.length < 2) return;

    // Gamla inspirationsrutor ersätts av kapitlens bilder
    grid.querySelectorAll(':scope > .tambur-insp').forEach(function (el) { el.remove(); });
    grid.classList.remove('tambur-collection-grid--insp');

    function mall(namn) {
      var t = data.querySelector('template[data-serie-mall="' + namn + '"]');
      return t ? t.content.cloneNode(true) : null;
    }
    var meny = document.createElement('nav');
    meny.className = 'serie-hoppa';
    meny.setAttribute('aria-label', 'Kapitel');
    var frag = document.createDocumentFragment();
    anvanda.forEach(function (g) {
      var rubrik = txt(data, 'data-t-' + g);
      var rad = document.createElement('li');
      rad.className = 'serie-kapitel';
      rad.id = 'serie-' + g;
      rad.innerHTML = '<h2></h2><p></p><span class="serie-kapitel__n"></span>';
      rad.querySelector('h2').textContent = rubrik;
      rad.querySelector('p').textContent = txt(data, 'data-t-' + g + '-text');
      rad.querySelector('.serie-kapitel__n').textContent = grupper[g].length + ' ' + txt(data, 'data-t-delar');
      frag.appendChild(rad);

      var a = document.createElement('a');
      a.href = '#serie-' + g;
      a.innerHTML = '<span></span><small>' + grupper[g].length + '</small>';
      a.querySelector('span').textContent = rubrik;
      meny.appendChild(a);

      if (g === 'duka') {
        var set = mall('set');
        if (set) {
          var setLi = document.createElement('li');
          setLi.className = 'serie-set-cell';
          setLi.appendChild(set);
          frag.appendChild(setLi);
        }
      }
      var bild = mall(g);
      grupper[g].forEach(function (k, i) {
        frag.appendChild(k);
        if (bild && i === Math.min(3, grupper[g].length - 1)) {
          var li = document.createElement('li');
          li.className = 'serie-kapitel-cell';
          li.appendChild(bild);
          frag.appendChild(li);
          bild = null;
        }
      });
    });
    grid.innerHTML = '';
    grid.appendChild(frag);
    wrap.parentNode.insertBefore(meny, wrap);
    grid.querySelectorAll('[data-serie-set]').forEach(initSet);
    initPunkter(grid);

    // Markera kapitlet man är i
    var lankar = meny.querySelectorAll('a');
    function markera() {
      var top = meny.getBoundingClientRect().bottom + 40, akt = null;
      grid.querySelectorAll(':scope > .serie-kapitel').forEach(function (k) { if (k.getBoundingClientRect().top < top) akt = k.id; });
      lankar.forEach(function (l, i) { l.classList.toggle('is-on', akt ? l.getAttribute('href') === '#' + akt : i === 0); });
    }
    window.addEventListener('scroll', markera, { passive: true });
    markera();
  }

  /* ---------- Läs mer i berättelsen ---------- */
  function initLasMer() {
    document.querySelectorAll('[data-serie-las]').forEach(function (b) {
      var mer = b.parentNode.querySelector('[data-serie-mer]');
      if (!mer) return;
      var mer_text = b.textContent.trim(), mindre = txt(b, 'data-mindre');
      b.addEventListener('click', function () {
        mer.hidden = !mer.hidden;
        b.textContent = mer.hidden ? mer_text : mindre;
      });
    });
  }

  function init() {
    initPunkter();
    initRemsa();
    initKomplettera();
    initKapitel();
    initLasMer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', placeraPunkter);
})();
